import { AfterContentInit, Component, ContentChild, DoCheck, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormControlDirective, FormControlName, NgModel } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'townip-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss']
})
export class InputPasswordComponent implements OnInit, AfterContentInit, OnDestroy, DoCheck {

  @Input()
  public displayErrors = true;

  @ContentChild(NgModel, /* TODO: add static flag */ {})
  public accessor: NgModel;

  @ContentChild(FormControlDirective, /* TODO: add static flag */ {})
  public reactiveAccessor: FormControlDirective;

  @ContentChild(FormControlName, /* TODO: add static flag */ {})
  public reactiveGroupedAccessor: FormControlName;

  public label: string;

  public mainAccessor: FormControlName | FormControlDirective | NgModel;

  public minChars: number;
  public maxChars: number;

  public validityChecked = false;
  public oneLcValid: boolean;
  public oneUcValid: boolean;
  public oneNumValid: boolean;
  public minCharsValid: boolean;
  public maxCharsValid = true;
  public noSpecialValid = true;


  // oneScValid: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  public ngOnInit(): void {
    this.minChars = environment.minPasswordLength;
    this.maxChars = environment.maxPasswordLength;
  }

  public ngAfterContentInit(): void {
    this.getLabel();

    // Reactive forms grouped mode. (ex: when using FormGroup)
    if (this.reactiveGroupedAccessor) {
      this.initReactiveGroupMode();
      return;
    }

    // Reactive forms mode
    if (this.reactiveAccessor) {
      this.initReactiveMode();
      return;
    }

    // Template-driven forms-mode
    this.initTemplateMode();
  }

  public ngOnDestroy(): void {

  }

  public ngDoCheck(): void {
    if (!this.mainAccessor) {
      return;
    }

    const value = this.mainAccessor.value;
    const numPattern = new RegExp('[0-9]');
    const charPattern = new RegExp('[a-z]');
    const upCharPattern = new RegExp('[A-Z]');
    const noSpecialCharsPattern = new RegExp('[^a-zA-Z0-9]');

    this.maxCharsValid = value.length <= this.maxChars;
    const minCharsValid = value.length >= this.minChars;
    const oneNumValid = numPattern.test(value);
    const oneLcValid = charPattern.test(value);
    const oneUcValid = upCharPattern.test(value);
    const noSpecialValid = noSpecialCharsPattern.test(value);

    // For any that are passes, update immediately.
    if (minCharsValid) {
      this.minCharsValid = true;
    }
    if (oneNumValid) {
      this.oneNumValid = true;
    }
    if (oneLcValid) {
      this.oneLcValid = true;
    }
    if (oneUcValid) {
      this.oneUcValid = true;
    }

    this.noSpecialValid = !noSpecialValid;

    if (this.mainAccessor.touched) {
      this.validityChecked = true;
    }

    // Not dirty check until we can find a way to hook an event on blur.
    if (this.mainAccessor.invalid && this.mainAccessor.touched) {
      this.minCharsValid = minCharsValid;
      this.oneNumValid = oneNumValid;
      this.oneLcValid = oneLcValid;
      this.oneUcValid = oneUcValid;
      this.noSpecialValid = !noSpecialValid;
      this.addInvalidClasses();
    }
  }

  private initTemplateMode(): void {
    if (!this.accessor) {
      return;
    }

    this.mainAccessor = this.accessor;
    this.accessor.statusChanges.subscribe((status) => {
      if (this.accessor.invalid && this.accessor.touched) {
        this.addInvalidClasses();
      } else {
        this.removeInvalidClasses();
      }
    });
  }

  private initReactiveMode(): void {
    if (!this.reactiveAccessor) {
      return;
    }

    this.mainAccessor = this.reactiveAccessor;
    this.reactiveAccessor.form.statusChanges.subscribe((status) => {
      if (this.reactiveAccessor.invalid && this.reactiveAccessor.touched) {
        this.addInvalidClasses();
      } else {
        this.removeInvalidClasses();
      }
    });
  }

  private initReactiveGroupMode(): void {
    if (!this.reactiveGroupedAccessor) {
      return;
    }

    this.mainAccessor = this.reactiveGroupedAccessor;
    this.reactiveGroupedAccessor.statusChanges.subscribe((status) => {
      if (this.reactiveGroupedAccessor.invalid && this.reactiveGroupedAccessor.touched) {
        this.addInvalidClasses();
      } else {
        this.removeInvalidClasses();
      }
    });
  }

  private getLabel(): void {
    const el: Element = this.el.nativeElement.querySelector('label');
    if (el) {
      this.label = el.textContent;
    } else {
      console.warn('No <label> inside the input.');
    }
  }

  private addInvalidClasses(): void {
    if (this.displayErrors === false) {
      return;
    }

    try {
      const el = this.el.nativeElement.querySelector('.form-control');
      this.renderer.addClass(el, 'is-invalid');
    } catch (e) {
      console.warn(`Control ${this.label} is not supported.`);
      console.warn(`
        Make sure it has the \'form-control custom-control\' class.
        If it's a custom form control, make sure you have the proper styling in .custom-control depending
        on the type of custom control you are using.
      `);
    }
  }

  private removeInvalidClasses(): void {
    if (this.displayErrors === false) {
      return;
    }

    try {
      const el = this.el.nativeElement.querySelector('.form-control');
      this.renderer.removeClass(el, 'is-invalid');
    } catch (e) {
      console.warn(`Control ${this.label} is not supported.`);
      console.warn(`
        Make sure it has the \'form-control custom-control\' class.
        If it's a custom form control, make sure you have the proper styling in .custom-control depending
        on the type of custom control you are using.
      `);
    }
  }
}
